import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { excludedGiftVoucherSiteIds } from '../helpers/giftVoucherVenueExclusions';
import { SiteStatusType } from '../interfaces/ISite';
import { IApplicationState } from '../store';

// Returns only the currencies that have at least one eligible venue in the booking system.
// Eligibility criteria mirror useLocationsWithVenues: excluded sites, external booking,
// reservation-only, and inactive status are all filtered out.
const useVenueBackedCurrencies = () => {
	const currencyState = useSelector((state: IApplicationState) => state.currencies);
	const allSites = useSelector((state: IApplicationState) => state.sites.sites);

	const currencies = useMemo(() => {
		// Collect currency IDs that have at least one eligible venue
		const eligibleCurrencyIds = new Set<number>();

		for (const venue of (allSites ?? [])) {
			if (excludedGiftVoucherSiteIds.includes(venue.siteId)) continue;
			if (venue.useExternalBookingUrl) continue;
			if (venue.reservationPortal) continue;
			if (venue.siteStatusTypeId !== SiteStatusType.Active && venue.siteStatusTypeId !== SiteStatusType.Deploying) continue;

			eligibleCurrencyIds.add(venue.currencyId);
		}

		return currencyState.currencies.filter(c => eligibleCurrencyIds.has(c.id));
	}, [allSites, currencyState.currencies]);

	return {
		currencies,
		isLoading: currencyState.isLoading,
		hasLoaded: currencyState.hasLoaded,
		loadFailed: currencyState.loadFailed,
	};
};

export default useVenueBackedCurrencies;
